module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"keywords":"keywords","average_position":"Average ranking"},"fr":{"keywords":"mots clés","average_position":"Position Moyenne"},"de":{"keywords":"Schlüsselwörter","average_position":"Durchschnittliche Position"}}')
  delete Component.options._Ctor
}
